import { Form, Tab, TabGroup } from '@servicetitan/design-system';
import { useEffect, useState } from 'react';
import CallStatePanel from './panels/CallStatePanel';
import QueuesPanel from './panels/QueuesPanel';
import SessionsPanel from './panels/SessionsPanel';
import UsersPanel from './panels/UsersPanel';
import AuthPanel from './panels/AuthPanel';
import IdsPanel from './panels/IdsPanel';
import TasksPanel from './panels/TasksPanel';
import InboxPanel from './panels/InboxPanel';
import DebugModule, { useDebugMode } from '@modules/DebugModule';

const panels = [
  {
    key: 'ids',
    label: 'IDs',
    content: <IdsPanel />,
  },
  {
    key: 'call',
    label: 'Call',
    content: <CallStatePanel />,
  },
  {
    key: 'queues',
    label: 'Queues',
    content: <QueuesPanel />,
  },
  {
    key: 'sessions',
    label: 'Sessions',
    content: <SessionsPanel />,
  },
  {
    key: 'users',
    label: 'Users',
    content: <UsersPanel />,
  },
  {
    key: 'auth',
    label: 'Auth',
    content: <AuthPanel />,
  },
  {
    key: 'tasks',
    label: 'Tasks',
    content: <TasksPanel />,
  },
  {
    key: 'inbox',
    label: 'Inbox',
    content: <InboxPanel />,
  },
  {
    key: 'frame',
    label: 'Frame',
    content: '',
  },
];

const DebugPanel = () => {
  const [activeTab, setActiveTab] = useState('ids');
  const debugMode = useDebugMode();

  useEffect(() => {
    const frame = document.getElementById('hiddenFrame');
    if (frame && activeTab === 'frame') {
      frame.style.display = 'block';
    } else if (frame) {
      frame.style.display = 'none';
    }
  }, [activeTab]);

  return (
    <div
      style={{
        width: 550,
        borderRight: '1px solid #bbb',
        backgroundColor: '#ddd',
      }}
    >
      <div
        style={{
          padding: '15px 15px 0 15px',
          borderBottom: '1px solid #bbb',
        }}
      >
        <TabGroup>
          {panels.map(({ key, label }) => (
            <Tab
              key={key}
              label={key}
              active={activeTab === key}
              onClick={() => setActiveTab(key)}
            >
              {label}
            </Tab>
          ))}
        </TabGroup>
      </div>
      <div
        style={{
          height: 'calc(100vh - 150px)',
          overflow: 'auto',
          padding: '0 15px 15px 15px',
        }}
      >
        {panels.find((p) => p.key === activeTab)?.content}

        <Form.Checkbox
          style={{ paddingTop: '20px' }}
          label='Debug Mode'
          description='Display debugging UI components throughout the app.'
          className='m-b-1'
          checked={debugMode.enabled}
          onChange={(_val, checked) => {
            DebugModule.setDebugMode(checked);
          }}
        />
      </div>
    </div>
  );
};

export default DebugPanel;
